import React, { Component } from 'react';
import './App.scss';

import Bidding from './pages/Bidding';
import BiddingHistory from './pages/BiddingHistory';

import { cookie } from './approach/base';

import { HashRouter, Switch, Route, Link } from 'react-router-dom';
import {
    ContainerOutlined,
} from '@ant-design/icons';

import { Layout, Menu } from 'antd';
const { SubMenu } = Menu;

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        
    }

    onClick = item => {
        this.setState({
            selectedKeys: [item.key]
        });
    };

    render() {
        return (
            <div
                className="router-content"
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    backgroundColor: 'white',
                    overflowY: 'auto'
                }}
            >
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={Bidding} />
                        <Route exact path="/history" component={BiddingHistory} />
                    </Switch>
                </HashRouter>
            </div>
        );
    }
}
